import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["label", "spinner"];
  static values = {
    imageId: String
  };

  connect() {
    this.isColorized = false;
    this.originalSrc = null;
  }

  toggle() {
    if (this.isColorized) {
      this.revertToOriginal();
    } else {
      this.colorize();
    }
  }

  colorize() {
    const imageElement = document.querySelector(`#image_${this.imageIdValue}`);
    if (!imageElement) return;

    this.originalSrc = imageElement.src;
    const colorizedSrc = this.originalSrc.replace("/1000x.jpg", "/1000xc.jpg");

    // Start showing sparkles immediately over the current image
    this.showLoading(imageElement);

    const tempImage = new Image();
    tempImage.onload = () => {
      // Stop sparkles
      this.hideLoading();

      // Then fade transition
      imageElement.style.opacity = "0";

      setTimeout(() => {
        imageElement.src = colorizedSrc;
        imageElement.style.opacity = "1";
        this.isColorized = true;
        this.labelTarget.textContent = "Original";
      }, 300);
    };

    tempImage.onerror = () => {
      this.hideLoading();
      imageElement.style.opacity = "1";
      alert("Colorized version not available for this photo");
    };

    tempImage.src = colorizedSrc;
  }

  revertToOriginal() {
    const imageElement = document.querySelector(`#image_${this.imageIdValue}`);
    if (!imageElement || !this.originalSrc) return;

    imageElement.style.opacity = "0";

    setTimeout(() => {
      imageElement.src = this.originalSrc;
      imageElement.style.opacity = "1";
      this.isColorized = false;
      this.labelTarget.textContent = "AI Colorize";
    }, 300);
  }

  showLoading(imageElement) {
    this.spinnerTarget.classList.remove("hidden");
    this.labelTarget.classList.add("hidden");

    imageElement.style.transition = "opacity 0.3s ease-in-out";

    this.createSparkles(imageElement);
  }

  hideLoading() {
    this.spinnerTarget.classList.add("hidden");
    this.labelTarget.classList.remove("hidden");

    this.removeSparkles();
  }

  createSparkles(imageElement) {
    const wrapper = imageElement.closest('.image-wrapper');
    if (!wrapper) {
      console.log('No image-wrapper found');
      return;
    }

    const sparkleContainer = document.createElement('div');
    sparkleContainer.className = 'sparkle-container';
    sparkleContainer.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: 1000;
      overflow: hidden;
    `;

    wrapper.style.position = 'relative';
    wrapper.appendChild(sparkleContainer);

    // Add sparkles more frequently for better visibility
    this.sparkleInterval = setInterval(() => {
      this.addSparkle(sparkleContainer);
    }, 150);

    // Add a few sparkles immediately
    for (let i = 0; i < 3; i++) {
      setTimeout(() => this.addSparkle(sparkleContainer), i * 50);
    }
  }

  addSparkle(container) {
    const sparkle = document.createElement('div');
    const size = Math.random() * 20 + 20;
    const left = Math.random() * 90 + 5;
    const top = Math.random() * 90 + 5;

    sparkle.innerHTML = '✨';
    sparkle.style.cssText = `
      position: absolute;
      left: ${left}%;
      top: ${top}%;
      font-size: ${size}px;
      animation: sparkleFloat 1.5s ease-out forwards;
      opacity: 0;
      filter: drop-shadow(0 0 3px rgba(255, 215, 0, 0.9));
    `;

    container.appendChild(sparkle);

    setTimeout(() => sparkle.remove(), 1500);
  }

  removeSparkles() {
    if (this.sparkleInterval) {
      clearInterval(this.sparkleInterval);
      this.sparkleInterval = null;
    }

    const sparkleContainer = document.querySelector('.sparkle-container');
    if (sparkleContainer) {
      setTimeout(() => sparkleContainer.remove(), 1500);
    }
  }
}

if (!document.querySelector('#sparkle-animation-style')) {
  const style = document.createElement('style');
  style.id = 'sparkle-animation-style';
  style.textContent = `
    @keyframes sparkleFloat {
      0% {
        opacity: 0;
        transform: translateY(0) scale(0);
      }
      50% {
        opacity: 1;
      }
      100% {
        opacity: 0;
        transform: translateY(-30px) scale(1.2);
      }
    }
  `;
  document.head.appendChild(style);
}
